<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text">Save Vehicle Forecast Template</h3>
</div>
<div>
  <p>When saving a Forecast Template into GFS, GFS determines the Scenario ID to save the data into by Column A VEH_SCEN_ID. The individual records are saved according the VEH_SCEN_DTL ID in column B. In addition, the VEH_SCEN_ID and the VEH_SCEN_DTL_ID are used in combination. Never change these IDs in a template, it will cause errors in the save.
    Adding a record to the template will cause errors as well.
    <br>
    <br>
    Do not change descriptions on the product details either as these changes will not be captured in the save. The forecast volumes and Comments will be saved to the VEH_SCEN_ID & VEH_SCEN_DTL_ID as defined in the scenario.  Product definition can only be changed through a change to the portfolio record.
  </p>
</div>
<div class="drag-and-drop-container">
  <h4>
    <span class="template-dropzone-label">Please Select File to select worksheets from. </span> (Required
    Format: .xls or .xlsx)
  </h4>
</div>
<div (files)="upload($event)" appDrag class="dropzone">
  <div class="text-wrapper">
    <div class="centered">Drag and Drop Files Here</div>
    <p class="centered">or</p>
    <div>
      <app-upload-button (eventEmitter)="upload($event)" [apiUrl]="excelService.excelSheetUrl"
                         class="upload centered app-upload-button">
      </app-upload-button>
    </div>
  </div>
</div>
